/**
 * @generated SignedSource<<995284d6e38af26efacbb39850cfab5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateMaintenanceUpdateInput = {
  clientMutationId?: string | null | undefined;
  data: MaintenanceUpdateInput;
  id: string;
};
export type MaintenanceUpdateInput = {
  clientMutationId?: string | null | undefined;
  id?: string | null | undefined;
  isUpdating: boolean;
};
export type MaintenanceToggleButton_UpdateMutation$variables = {
  input: UpdateMaintenanceUpdateInput;
};
export type MaintenanceToggleButton_UpdateMutation$data = {
  readonly Admin: {
    readonly Maintenance: {
      readonly updateMaintenanceUpdate: {
        readonly data: {
          readonly node: {
            readonly id: string;
            readonly isUpdating: boolean;
          };
        };
      } | null | undefined;
    };
  };
};
export type MaintenanceToggleButton_UpdateMutation = {
  response: MaintenanceToggleButton_UpdateMutation$data;
  variables: MaintenanceToggleButton_UpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MaintenanceAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Maintenance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "UpdateMaintenanceUpdatePayload",
            "kind": "LinkedField",
            "name": "updateMaintenanceUpdate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "maintenanceUpdateEdge",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MaintenanceUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUpdating",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MaintenanceToggleButton_UpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MaintenanceToggleButton_UpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9f5910ebc772f30fe09a46ac279411a1",
    "id": null,
    "metadata": {},
    "name": "MaintenanceToggleButton_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation MaintenanceToggleButton_UpdateMutation(\n  $input: UpdateMaintenanceUpdateInput!\n) {\n  Admin {\n    Maintenance {\n      updateMaintenanceUpdate(input: $input) {\n        data {\n          node {\n            id\n            isUpdating\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec871e1f4b68df21f69a77245b65cc58";

export default node;
